/**
 * Which conversation the user currently has open, if any.
 *
 * GlobalNotifications toasts incoming chat messages app-wide, but must stay quiet for the
 * conversation already on screen — the stylist watches that message arrive inline, and a
 * toast on top of it is just noise. ConversationPage publishes the peer id it's showing
 * while mounted, and GlobalNotifications checks it.
 *
 * Deliberately a plain module rather than route-matching: ConversationPage is reached by
 * route (/chat/:userId) but is ALSO embedded as a widget inside the reservation modals, so
 * the open conversation can't be derived from the URL.
 */
let activePeerId: string | null = null;

export const setActiveConversation = (peerId: string | null): void => {
  activePeerId = peerId || null;
};

export const isViewingConversation = (peerId?: string | null): boolean =>
  !!peerId && activePeerId === peerId;
